<template>
  <div :style="style"
       :class="{open: show}"
       class="context-menu"
       tabindex="-1"
       @blur="close"
       @click="close"
       @contextmenu.capture.prevent
  >
    <ul class="dropdown-menu">
      <slot :userData="userData" />
    </ul>
  </div>
</template>

<script>
// From https://github.com/rawilk/vue-context
export default {
  data () {
    return {
      top: null,
      left: null,
      userData: null,
      show: false
    }
  },

  computed: {
    // Get the position of the context menu.
    style () {
      return this.show ? { top: `${this.top}px`, left: `${this.left}px` } : {}
    }
  },

  methods: {
    // Close the menu.
    close () {
      this.top = null
      this.left = null
      this.userData = null
      this.show = false
    },

    /**
      * Open the menu.
      *
      * @param event
      * @param userData
      */
    async open (event, userData) {
      this.userData = userData

      const top = event.clientY
      const left = event.clientX

      this.show = true

      await this.$nextTick()
      this.setMenu(top, left)
      this.$el.focus()
    },

    /**
      * Set menu coordinates.
      *
      * @param top
      * @param left
      */
    setMenu (top, left) {
      let largestHeight = window.innerHeight - this.$el.offsetHeight - 25
      let largestWidth = window.innerWidth - this.$el.offsetWidth - 25

      if (top > largestHeight) {
        top = largestHeight
      }

      if (left > largestWidth) {
        left = largestWidth
      }

      this.top = top
      this.left = left
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/scss/variables';

  .context-menu {
    position: fixed;
    z-index: 99999;
    display: block;
    padding: 0;
    margin: 0;
    outline: none;

    ul.dropdown-menu {
      display: block;
      padding: 0;
      margin: 0;
      list-style: none;
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.35s;

      li {
        display: block;
        padding: 8px 15px;
        font-weight: normal;
        cursor: pointer;
        user-select: none;
        border-radius: $border-radius;

        &:hover {
          color: $black;
          background: $gray-300;
        }
      }
    }

    &.open {
      .dropdown-menu {
        visibility: visible;
        opacity: 1;
      }
    }
  }
</style>
